import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent  implements OnInit, OnDestroy { 
  constructor(private router: Router){
   
  }
   ngOnInit() {
    document.addEventListener("keydown", this.preventArrowNavigation, true);
  }
   ngOnDestroy() {
    document.removeEventListener("keydown", this.preventArrowNavigation, true);
  }

  preventArrowNavigation(event: KeyboardEvent) {
    const arrows = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
    if (arrows.includes(event.key)) {
      event.preventDefault();   
      event.stopPropagation();  
    }
  }
}
